import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    Card,
    ProTableOt,
    Form,
    useProTableOt,
    setParamsFilter,
    Tag,
    Select,
} from "../../ui/ot";
// import { useQuestionAndAnswer } from "../controller/question_and_answer_controller";
import TagStructureManagementForm from "./tag_structure_management_form";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router-dom";


const TagStructureManagementTable = ({
    permission_level = null, 
    rowKey = "tagfield",
    keyPrefix = "cataloging.tag_structure_management",
    showAllColumns = true,
    propsShowColumns,
    propsFrameworkcode,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }//selectInfo
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const columns = [
        {
            title: t("tagfield"),
            key: "tagfield",
            dataIndex: "tagfield",
            align: "center",

        },
        {
            title: t("liblibrarian"),
            key: "liblibrarian",
            dataIndex: "liblibrarian",
            align: "center",
            width: 300
        },
        {
            title: t("libopac"),
            key: "libopac",
            dataIndex: "libopac",
            align: "center",
            width: 300

        },
        {
            title: t("repeatable"),
            key: "repeatable",
            dataIndex: "repeatable",
            align: "center",
            render: (text, record, index) => {
                if (parseInt(text) === 1) {
                    return <Row justify="center">
                        <Col>
                            <Tag color="success">
                                {t('yes')}
                            </Tag>
                        </Col>
                    </Row>
                }
                else {
                    return <Row justify="center">
                        <Col>
                            <Tag color="cyan-inverse">
                                {t('no')}
                            </Tag>
                        </Col>
                    </Row>
                }
            }
        },
        {
            title: t("mandatory"),
            key: "mandatory",
            dataIndex: "mandatory",
            align: "center",
            render: (text, record, index) => {
                if (parseInt(text) === 1) {
                    return <Row justify="center">
                        <Col>
                            <Tag color="success">
                                {t('yes')}
                            </Tag>
                        </Col>
                    </Row>
                }
                else {
                    return <Row justify="center">
                        <Col>
                            <Tag color="cyan-inverse">
                                {t('no')}
                            </Tag>
                        </Col>
                    </Row>
                }
            }
        },
        {
            title: t("important"),
            key: "important",
            dataIndex: "important",
            align: "center",
            render: (text, record, index) => {
                if (parseInt(text) === 1) {
                    return <Row justify="center">
                        <Col>
                            <Tag color="success">
                                {t('yes')}
                            </Tag>
                        </Col>
                    </Row>
                }
                else {
                    return <Row justify="center">
                        <Col>
                            <Tag color="cyan-inverse">
                                {t('no')}
                            </Tag>
                        </Col>
                    </Row>
                }
            }
        },
        {
            title: t("authorised_value"),
            key: "authorised_value",
            dataIndex: "authorised_value",
            align: "center",
        },
        {
            title: t("ind1_defaultvalue"),
            key: "ind1_defaultvalue",
            dataIndex: "ind1_defaultvalue",
            align: "center",
        },
        {
            title: t("ind2_defaultvalue"),
            key: "ind2_defaultvalue",
            dataIndex: "ind2_defaultvalue",
            align: "center",
        },
        {
            title: t("total_columns"),
            key: "subfield",
            dataIndex: "subfield",
            align: "center",
            render: (text, record, index) => {
                return <Row justify="center">
                    <Col>
                        <Tag color="gold-inverse">
                            {text?.length}
                        </Tag>
                    </Col>
                </Row>
            }
        },
    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : ['question_and_answer_data', 'title'])

    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [frameworkcode, setFrameworkcode] = useState(propsFrameworkcode || '');
    const [createFrameworkcode, setCreateFrameworkcode] = useState(propsFrameworkcode || '');
    const [createSubfield, setCreateSubfield] = useState([]);

    const [form] = Form.useForm();
    const navigate = useNavigate()


    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reload();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }

    };
    const onBefore = ({ axiosMode, status, values }) => {
        if (axiosMode !== "get") {
            setModalLoading(true);
        }
    };
    const addByFramework = (createFrameworkcode) => {
        TagStructureController
            .getData({
                frameworkcode: createFrameworkcode
            })
            .then((response) => {
                let subfield = []
                let data = response?.data || []
                data = data.map((value) => {
                    (value?.subfield || []).forEach((ele) => {
                        subfield.push({
                            ...ele,
                            frameworkcode: frameworkcode,
                            tagfield: value?.tagfield,
                            "hidden_opac": ele?.hidden ? 1 : 0,
                            "hidden": ele?.hidden ? 1 : 0,
                            //這裡欄位待確認
                            "hidden_staff_interface": 0,
                            "hidden_editor": 0,
                            "hidden_collapsed": 0,
                            "hidden_flagged": 0,
                            "LINK": ele?.link,
                            "repeatable": ele?.repeatable ? 1 : 0,
                            "mandatory": ele?.mandatory ? 1 : 0,
                            "important": ele?.important ? 1 : 0,
                        })
                    })
                    return {
                        ...value,
                        frameworkcode: frameworkcode,
                        mandatory: value?.mandatory === "1" ? true : false,
                        important: value?.important === "1" ? true : false,
                        repeatable: value?.repeatable === "1" ? true : false,
                    }
                })
                TagStructureController.postData(data)

                setCreateSubfield(subfield)

            })
    }

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    const TagStructureManagementController = useCRUDController({
        apiRoute: "/koha/marc/tagStructure",
        onFinish,
        onBefore
    })
    const TagStructureController = useCRUDController({
        apiRoute: "/koha/marc/tagStructure",
        onFinish: ({ axiosMode, status, values }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    setCreateSubfield((pre) => {
                        console.log({ pre })
                        subfieldStructureManagementController.postData(pre)
                        return pre
                    })

                }
            } else if (status === "error") {
                if (axiosMode === "post") {
                    message.error(t('add_failure'));
                    actionRef.current.reloadAndRest();

                }
            }
        },
        onBefore
    })
    const FrameworkManagementController = useCRUDController({
        apiRoute: "/koha/bib/framework",
        onFinish,
        onBefore
    })
    const subfieldStructureManagementController = useCRUDController({
        apiRoute: "/koha/marc/subfieldStructure",
        onFinish: ({ axiosMode, status, values }) => {
            if (status === "success") {
                if (axiosMode === "post") {
                    message.success(t('add_success'));
                    actionRef.current.reloadAndRest();
                    setModalLoading(false);
                }
            } else if (status === "error") {
                if (axiosMode === "post") {
                    message.error(t('add_failure'));
                    actionRef.current.reloadAndRest();
                    setModalLoading(false);

                }
            }
        },
        // onBefore
    })
    useEffect(() => {
        checkAll();
        FrameworkManagementController.getData({
        })
    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [frameworkcode])
    return (<Row>
        <Col span={24}>
            <Row align="middle">
                <Col>
                    <Typography.Title level={3}>
                        {t('marc_bibliographic_framework')}：
                    </Typography.Title>
                </Col>
                <Col>
                    <Select
                        value={frameworkcode}
                        options={FrameworkManagementController.ResponseData?.map((value) => {
                            return {
                                label: value?.frameworktext,
                                value: value?.frameworkcode
                            }
                        })}
                        onChange={(value) => {
                            setFrameworkcode(value)
                        }}
                    />
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <ProTableOt
                searchParams={{
                    frameworkcode
                }}
                formMode={true}
                actionRef={actionRef}
                headerTitle={TagStructureManagementController.ResponseData.length === 0 &&
                    <Col span={24}>
                        <Row gutter={[4, 4]} align="middle">
                            <Col>
                                {t('create_framework_method')}:
                            </Col>
                            <Col>
                                <Select
                                    value={createFrameworkcode}
                                    options={FrameworkManagementController.ResponseData?.map((value) => {
                                        return {
                                            label: value?.frameworktext,
                                            value: value?.frameworkcode
                                        }
                                    })}
                                    onChange={(value) => {
                                        setCreateFrameworkcode(value)
                                    }}
                                >
                                </Select>
                            </Col>
                            <Col>
                                <Popconfirm
                                    title={t('add_using_framework')}
                                    onConfirm={() => {
                                        addByFramework(createFrameworkcode)
                                    }}

                                >
                                    <Button
                                        loading={modalLoading}
                                    >
                                        {t('confirm')}
                                    </Button>
                                </Popconfirm>
                            </Col>
                        </Row>

                    </Col>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return []
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        frameworkcode
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return TagStructureManagementController.getData(newParams);
                    // return []
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }

                propsPatchProcess={(data) => {
                    return {
                        ...data,
                        axiosMode: "patch"
                    }
                }}
                initialValues={{
                    "axiosMode": "post",
                }}
                propsPostOnBefore={(data) => {
                    return {
                        ...data,
                        axiosMode: "post"
                    }
                }}
                propsUseData={() => {
                    return {
                        postData: (formData) => {

                            let postData = formData.map((formValue) => {
                                return {
                                    ...formValue,
                                }

                            })
                            TagStructureManagementController.postData(postData)
                        },
                        patchData: (formData) => {
                            let patchData = formData.map((formValue) => {
                                return {
                                    ...formValue,
                                }
                            })
                            TagStructureManagementController.patchData(patchData)
                        },
                        deleteData: TagStructureManagementController.deleteData
                    }
                }}
                PropsPatchForm={<TagStructureManagementForm />}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatch={permission_level === 1 ? true : false}
                propsDelete={permission_level === 1 ? true : false}
                propsPost={permission_level === 1 ? true : false}
                propsWidth={600}
                scroll={{
                    x: "100%",
                }}
                extraActionRender={(record) => {
                    return (
                    permission_level === 1 ? 
                    <Col>
                        <Button
                            onClick={() => {
                                navigate(`../subfield_structure_management?frameworkcode=${record?.frameworkcode || " "}&tagfield=${record?.tagfield}`)
                            }}>
                            {t('edit_subfield')}
                        </Button>
                    </Col>
                    : <></>)
                }}
            />
        </Col>
    </Row>)

}
const TagStructureManagement = ({
    keyPrefix = "cataloging.tag_structure_management",
    permission_level = null,
}) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const frameworkcode = searchParams.get('frameworkcode')

    return (
        <Row
            gutter={[10, 20]}
        >
            <Col span={24}>
                <TagStructureManagementTable
                    keyPrefix={keyPrefix}
                    propsFrameworkcode={frameworkcode}
                    permission_level={permission_level}
                />
            </Col>
        </Row>
    );
};
export { TagStructureManagementTable }
export default TagStructureManagement;
